var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"root-default-page"},[_c('div',{staticClass:"default-page"},[_c('brand-partial'),_c('about-partial'),_c('milestones-partial'),_c('blog-partial',{attrs:{"posts":_vm.posts}}),_c('partners-partial'),_c('faq-partial'),_c('community-partial')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }